module.exports = __webpack_public_path__ + "img/keyboard-brightness-low.f0407d03.svg";